<template>
  <div
    style="
      max-width: 240px;
      margin-right: 1rem;
      margin-top: 1.5rem;
      display: inline-block;
    "
    class="hidden-xs-only d-md-inline-block"
    v-if="currentUser.userId != undefined"
  >
    <v-autocomplete
      autocomplete="off"
      :label="$t('dashboard.name')"
      v-model="dashboardId"
      :items="dashboards"
      item-text="name"
      item-value="dashboardId"
      prepend-icon="mdi-calendar-today"
      required
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "DashboardSwitcherNavbar",
  data() {
    return {
      dashboardId: null,
    };
  },

  computed: {
    ...mapState("dashboards", ["dashboards"]),
    ...mapState("users", ["currentUser"]),
  },

  methods: {
    ...mapActions("dashboards", ["getDashboards", "setDefault", "getDefault"]),
  },

  async created() {
    await this.getDashboards();
  },

  watch: {
    async dashboardId(newVal) {
      let id = this.dashboardId;
      this.dashboardId = null;
      if (newVal !== null) {
        for (let i = 0; i < this.dashboards.length; i++) {
          let e = this.dashboards[i];

          if (e.dashboardId == id) {
            await this.setDefault({ dashboardId: e.dashboardId });
            await this.getDefault();

            let path = `/dashboard/${id}`;
            this.$router.push(path);
            if (this.isInsideDashboard) {
              this.$router.go();
            }
            break;
          }
        }
      }
    },
  },
};
</script>